import React from 'react';
import classNames from 'classnames/bind';
import IcWhatsapp from 'assets/images/backoffice/capital/ic-whatsapp.png';
import IcEmail from 'assets/images/backoffice/capital/ic-email.png';
import styles from './Button.css';

const cx = classNames.bind(styles);

function getClassName(type, full, center, disabled) {
  return cx({
    default: type === undefined,
    full,
    disabled,
    'default-outline': type === 'outline',
    'content-center': center,
  });
}

function Button(props) {
  const { title, icon, full, center, disabled, btnType, ...rest } = props;

  function ButtonContent() {
    let Img = null;
    if (icon === 'whatsapp') Img = IcWhatsapp;
    if (icon === 'email') Img = IcEmail;
    return (
      <span className={styles['content-wrapper']}>
        <img src={Img} className={styles[`icon-${icon}`]} />
        {title}
      </span>
    );
  }

  if (rest.href) {
    return (
      <a {...rest} className={getClassName(btnType, full, center, disabled)}>
        <ButtonContent />
      </a>
    );
  }

  return (
    <button
      {...rest}
      className={getClassName(btnType, full, center, disabled)}
      disabled={disabled}
    >
      <ButtonContent />
    </button>
  );
}

export default Button;
